// STAT TYPES
export const FAILED = 'failed';
export const FINISHED = 'finished';
export const IN_PROGRESS = 'in_progress';
export const QUEUED = 'queued';
export const TOTAL = 'total';
export const WAITING = 'waiting';

export const STATS_TYPES = [QUEUED, WAITING, IN_PROGRESS, FAILED];
